import React from 'react';
import Badge from '../common/Badge';
import { theme } from '../../config/theme';
import { FileIcon } from '../icons/Icons';

const DocumentViewer = ({ document }) => {
  const getStatusVariant = (status) => {
    const map = {
      pending: 'warning',
      verified: 'success',
      rejected: 'error',
    };
    return map[status] || 'default';
  };

  const containerStyles = {
    border: `1px solid ${theme.colors.gray[200]}`,
    borderRadius: theme.borderRadius.lg,
    padding: theme.spacing.lg,
    marginBottom: theme.spacing.md,
    backgroundColor: theme.colors.white,
  };

  const headerStyles = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: theme.spacing.md,
  };

  const iconWrapperStyles = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: theme.colors.gray[400],
    marginBottom: theme.spacing.md,
  };

  const isPDF = document.file_url?.toLowerCase().endsWith('.pdf');

  return (
    <div style={containerStyles}>
      <div style={headerStyles}>
        <div>
          <h4 style={{ fontSize: theme.typography.fontSize.base, fontWeight: theme.typography.fontWeight.semibold, marginBottom: theme.spacing.xs }}>
            {document.document_type.replace('_', ' ').toUpperCase()}
          </h4>
          {document.document_number && (
            <div style={{ fontSize: theme.typography.fontSize.sm, color: theme.colors.text.secondary }}>
              Number: {document.document_number}
            </div>
          )}
        </div>
        <Badge variant={getStatusVariant(document.verification_status)}>
          {document.verification_status?.toUpperCase()}
        </Badge>
      </div>

      {isPDF ? (
        <div style={{ padding: theme.spacing.xl, backgroundColor: theme.colors.gray[50], borderRadius: theme.borderRadius.md, textAlign: 'center' }}>
          <div style={iconWrapperStyles}>
            <FileIcon size={64} />
          </div>
          <a 
            href={document.file_url} 
            target="_blank" 
            rel="noopener noreferrer"
            style={{ color: theme.colors.primary.main, textDecoration: 'none', fontWeight: theme.typography.fontWeight.medium }}
          >
            View PDF Document
          </a>
        </div>
      ) : (
        <img 
          src={document.file_url} 
          alt={document.document_type}
          style={{ width: '100%', maxHeight: '400px', objectFit: 'contain', borderRadius: theme.borderRadius.md, border: `1px solid ${theme.colors.gray[200]}` }}
        />
      )}
    </div>
  );
};

export default DocumentViewer;